import React from 'react';
import { NavLink } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { Helmet } from 'react-helmet';

import axios from 'axios';

import Search from './components/Search.js';
import Properties from './components/Properties';
import Testimonials from './components/Testimonials';

class Home extends React.Component {

    state = {
        featured: [],
    };

    componentDidMount() {
        axios.get("https://api-v2.plumproperties.im/properties?featured=true")
        .then((res) => {
            this.setState({
                featured: res.data
            });
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Partners Real Estate - Find your perfect home on the Isle of Man</title>
                </Helmet>

                <header className="large">
                    <div>
                        <div className={"tradingNames"}>
                            <div>
                                <img src={require('../images/property-wise.png')} alt={"Property Wise"} />
                                <img src={require('../images/harmony-homes.png')} alt={"Harmony Homes"} />
                                <img src={require('../images/plum-properties.png')} alt={"Plum Properties"} />
                            </div>
                            <h3>Brands owned by Partners Real Estate Group</h3>
                        </div>
                        <Search />
                        <div>
                            <Link to="/book-an-appraisal" className="btn" >Book an appraisal</Link>
                            <NavLink to="/sign-up" className="btn" >Create property alert</NavLink>
                        </div>
                        <img src={require('../images/logo-white.svg')} alt="Partners Real Estate Logo" />
                    </div>
                    <span />
                    <img src={require('../images/header.jpg')} alt={"Partners Real Estate Image"}/>
                </header>

                <section>
                    <div className="container">
                        <h2>Featured Properties</h2>
                        <Properties
                            properties={this.state.featured}
                        />
                        <NavLink to="/buy" className="btn center">See All Properties</NavLink>
                    </div>
                </section>
            </>
        );
    }
}

export default Home;
